<app-badge customToolTip [contentTemplate]="tooltip">
  <mat-icon class="material-icons-outlined">cloud_upload</mat-icon>
  <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.import_method }}:</span>
  <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['ftp_configuration']['host'] }}</span>
  <span> > </span>
  <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['ftp_configuration']['folder'] }}</span>
  <mat-icon class="material-icons-outlined icon-hover">info</mat-icon>
</app-badge>
<ng-template #tooltip>
  <div>
    <strong>Host: </strong>
    <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['ftp_configuration']['host'] }}</span>
  </div>
  <div>
    <strong>Port: </strong>
    <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['ftp_configuration']['port'] }}</span>
  </div>
  <div>
    <strong>{{ 'data_sources.custom_imports.folder' | translate }}: </strong>
    <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['ftp_configuration']['folder'] }}</span>
  </div>
</ng-template>
